module.exports = __webpack_public_path__ + "img/5_111.0955a6fb.png";